<template>
  <section class="app-main">
    <div class="top-bar">
      <el-input placeholder="输入预售批次" v-model="value" @change="search" style="width: 180px">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-button type="success" style="width: 100px; margin-left: 30px" @click="handleDialog(1)" >添加批次</el-button>
    </div>

    <el-card shadow="hover">
      <el-table :data="tableData" max-height="600" style="width: 100%" empty-text="暂无商品">
        <el-table-column prop="batch_number" label="预售批次" align="center" width="120" fixed></el-table-column>
        <el-table-column prop="order_period" label="订单期" align="center"></el-table-column>
        <el-table-column prop="purchase_period" label="采购期" align="center"></el-table-column>
        <el-table-column prop="delivery_date" label="发货期" align="center"></el-table-column>
        <el-table-column
          prop="arrival"
          label="到仓发货"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="created_at"
          label="添加时间"
          align="center"
          width="200"
        ></el-table-column>
        <el-table-column
          prop="up_price"
          align="center"
          label="查看 | 编辑"
          width="200"
        >
          <template slot-scope="scope">
            <el-tag
              type="danger"
              @click="handleDialog(2, scope.row)"
              style="width: 100px; cursor: pointer"
              >修改信息</el-tag
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="reloadData"
        layout="prev, pager, next, jumper"
        style="padding: 15px"
        :total="total"
        :page-size="20"
      ></el-pagination>
    </el-card>

    <el-dialog title="批次管理" :visible.sync="dialog" width="500px">
      <el-form label-position="left">
        <el-form-item label="订单期（天数）" label-width="130px">
          <el-input
            v-model="time_1"
            clearable
            autocomplete="off"
            style="width: 220px"
          ></el-input>
        </el-form-item>
        <el-form-item label="采购期（天数）" label-width="130px">
          <el-input
            v-model="time_2"
            clearable
            autocomplete="off"
            style="width: 220px"
          ></el-input>
        </el-form-item>
        <el-form-item label="发货期（天数）" label-width="130px">
          <el-input
            v-model="time_3"
            clearable
            autocomplete="off"
            style="width: 220px"
          ></el-input>
        </el-form-item>
        <el-form-item label="到仓发货（天数）" label-width="130px">
          <el-input
            v-model="time_4"
            clearable
            autocomplete="off"
            style="width: 220px"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog = false">取 消</el-button>
        <el-button type="primary" @click="handleAdd(row)">确 定</el-button>
      </div>
    </el-dialog>
  </section>
</template>



<script>
import { batch, batch_add, batch_put } from "@/api/goods.js";
export default {
  data() {
    return {
      id: "",
      value: "",
      tableData: [],
      total: 0,
      page: 1,
      batch: "",
      time_1: "",
      time_2: "",
      time_3: "",
      time_4: "",
      dialog: false,
      isPutValue:""
    };
  },
  methods: {
    search() {
      this.page = 1;
      this.getData();
    },
    getData() {
      this.tableData = [];
      let params = {
        page: this.page,
      };
      if (this.value != "") {
        params.batch_id = this.value;
      }
      batch(params).then((res) => {
        if (res) {
          this.tableData = res.data.data;
          this.total = res.data.total;
        } else {
          this.tableData = [];
        }
      });
    },
    reloadData(page) {
      this.page = page;
      this.getData();
    },
    handleDialog(value, row) {
      if (value == 2) {
        this.id = row.id;
        this.time_1 = row.order_period;
        this.time_2 = row.purchase_period;
        this.time_3 = row.delivery_date;
        this.time_4 = row.arrival;
      } else {
        this.time_1 = "";
        this.time_2 = "";
        this.time_3 = "";
        this.time_4 = "";
      }
      this.isPutValue = value
      this.dialog = true;
    },
    //  确定添加
    handleAdd() {
      let params = {
        order_period: this.time_1,
        purchase_period: this.time_2,
        delivery_date: this.time_3,
        arrival: this.time_4,
      };
      if (this.isPutValue == 1) {
        batch_add(params).then((res) => {
          if (res) {
            this.$message({
              type: "success",
              message: res.msg,
              duration: 1500,
            });
            this.getData();
            this.dialog = false;
          }
        });
      } else {
        batch_put(this.id, params).then((res) => {
          if (res) {
            this.$message({
              type: "success",
              message: res.msg,
              duration: 1500,
            });
            this.getData();
            this.dialog = false;
          }
        });
      }
    },
  },
  created() {
    this.getData();
  },
  activated() {
    this.getData();
  },
};
</script>

